import { useContext } from 'react'

import { Context, ModalContext } from '../context'

export const useModal = <Props extends Record<string, unknown>>() => useContext(Context) as ModalContext<Props>
